import script from "./TabEstado.vue?vue&type=script&setup=true&lang=js"
export * from "./TabEstado.vue?vue&type=script&setup=true&lang=js"

import "./TabEstado.vue?vue&type=style&index=0&id=1702e63e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1702e63e"]])

export default __exports__